/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import Form from 'forms/_.extend';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
  form: Form,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class DisableAccountMultiForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { form }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:trading_accounts.reasons.why_disable_multiple')}
          >
            <ElectroSelectWithOther
              field={form.$('disableAccountForm.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons
          form={form}
          submitTxt={t('general:actions.disable_account_plural')}
        />
      </React.Fragment>
    );
  }
}
